"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _reactDropzone = require("react-dropzone");

var _overrides = require("../../../utils/overrides");

var _Icon = _interopRequireDefault(require("../../general/Icon"));

var _Label = _interopRequireDefault(require("../Label"));

var _Text = _interopRequireDefault(require("../../typography/Text"));

var _FILE_TYPES = _interopRequireDefault(require("./FILE_TYPES"));

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'FilePicker');

var _ref2 = /*#__PURE__*/_react.default.createElement(_Icon.default, {
  name: "close"
});

function FilePicker(_ref) {
  var _classnames;

  var classesProp = _ref.classes,
      overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      onDrop = _ref.onDrop,
      onRemove = _ref.onRemove,
      limit = _ref.limit,
      accept = _ref.accept,
      disabled = _ref.disabled,
      maxSize = _ref.maxSize,
      minSize = _ref.minSize,
      multiple = _ref.multiple,
      id = _ref.id,
      name = _ref.name,
      files = _ref.files,
      label = _ref.label,
      labelMode = _ref.labelMode,
      isFullWidth = _ref.isFullWidth,
      placeholder = _ref.placeholder,
      activePlaceholder = _ref.activePlaceholder,
      hint = _ref.hint,
      error = _ref.error,
      info = _ref.info,
      isRequired = _ref.isRequired,
      isReadOnly = _ref.isReadOnly,
      props = (0, _objectWithoutProperties2.default)(_ref, ["classes", "overrides", "className", "onDrop", "onRemove", "limit", "accept", "disabled", "maxSize", "minSize", "multiple", "id", "name", "files", "label", "labelMode", "isFullWidth", "placeholder", "activePlaceholder", "hint", "error", "info", "isRequired", "isReadOnly"]);
  var theme = (0, _styles.useTheme)();
  var classes = (0, _overrides.useClasses)(useStyles, classesProp); // Overrides

  var override = (0, _overrides.getOverrides)(overridesProp, FilePicker.overrides); // Classes

  var rootClassName = (0, _classnames2.default)(classes.root, (_classnames = {}, (0, _defineProperty2.default)(_classnames, classes.isReadOnly, isReadOnly), (0, _defineProperty2.default)(_classnames, classes[labelMode], labelMode), (0, _defineProperty2.default)(_classnames, classes.isFullWidth, isFullWidth), (0, _defineProperty2.default)(_classnames, classes.errored, error), _classnames), classNameProp);
  var rootProps = {
    className: rootClassName
  };
  var labelProps = (0, _extends2.default)({
    className: classes.Label,
    isRequired: isRequired,
    hint: hint
  }, override.Label);
  var handleOnDrop = (0, _react.useCallback)(function (droppedFiles) {
    return onDrop(droppedFiles.filter(function (droppedFile) {
      return !files.some(function (file) {
        return file.name === droppedFile.name && file.size === droppedFile.size && file.type === droppedFile.type;
      });
    }));
  }, [files, onDrop]);

  var _useDropzone = (0, _reactDropzone.useDropzone)((0, _extends2.default)({
    onDrop: handleOnDrop,
    accept: accept,
    disabled: disabled,
    maxSize: maxSize,
    minSize: minSize,
    multiple: multiple
  }, props)),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps,
      isDragActive = _useDropzone.isDragActive;

  var renderFiles = (0, _react.useMemo)(function () {
    if (!files.length) return null;
    var filesList = files.map(function (file, i) {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: i,
        className: classes.file
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.iconNameContainer
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: classes.fileIcon
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        name: _FILE_TYPES.default[file.type] || 'file'
      })), /*#__PURE__*/_react.default.createElement(_Text.default, null, file.name)), /*#__PURE__*/_react.default.createElement("span", {
        onClick: function onClick() {
          return onRemove(file);
        },
        className: classes.clear
      }, _ref2));
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.files
    }, filesList);
  }, [classes.clear, classes.file, classes.fileIcon, classes.files, classes.iconNameContainer, files, onRemove]);
  var showDragzone = (0, _react.useMemo)(function () {
    return !(limit && files.length === limit);
  }, [files.length, limit]);
  var filePickerProps = (0, _extends2.default)({
    id: id,
    name: name,
    className: classes.input
  }, override.input);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, rootProps, override.root), label && /*#__PURE__*/_react.default.createElement(_Label.default, labelProps, label), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes.formControl
  }, override.formControl), showDragzone && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes.dropZone
  }, getRootProps()), /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({}, getInputProps(), filePickerProps)), isDragActive ? /*#__PURE__*/_react.default.createElement("div", {
    className: classes.dropZoneActive
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    className: classes.activePlaceholder
  }, activePlaceholder || placeholder)) : /*#__PURE__*/_react.default.createElement("div", {
    className: classes.dropZoneInactive
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "cloudUpload",
    className: classes.cloudUploadIcon,
    color: theme.colors.greySoft
  }), /*#__PURE__*/_react.default.createElement(_Text.default, {
    className: classes.placeholder
  }, placeholder))), renderFiles, info && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes.info
  }, override.info), info), error && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes.error
  }, override.error), error)));
}

FilePicker.overrides = ['root', 'filePicker', 'error', 'info', 'formControl', 'label'];
FilePicker.defaultProps = {
  labelMode: 'horizontal',
  onDrop: function onDrop() {},
  files: [],
  isReadOnly: false,
  override: {}
};
process.env.NODE_ENV !== "production" ? FilePicker.propTypes = {
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  onDrop: _propTypes.default.func,
  limit: _propTypes.default.number,

  /** Native filePicker id */
  id: _propTypes.default.string,

  /** Native filePicker name */
  name: _propTypes.default.string,
  files: _propTypes.default.array,
  label: _propTypes.default.string,
  labelMode: _propTypes.default.oneOf(['horizontal', 'vertical']),
  placeholder: _propTypes.default.string,
  activePlaceholder: _propTypes.default.string,

  /** Info popover */
  hint: _propTypes.default.string,

  /** Error will be displayed below the component with style changes */
  error: _propTypes.default.string,

  /** Info will be displayed below the component with style changes */
  info: _propTypes.default.string,
  isRequired: _propTypes.default.bool,
  isReadOnly: _propTypes.default.bool
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(FilePicker);

exports.default = _default;